const mission = (data) => {
	const missions = data.map(
		({ title: { rendered: title }, content: { rendered: description } }) => ({
			title,
			description,
		}),
	)

	return missions.reverse()
}

export default mission
